import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {useGetLink}  from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    image = "image",
    subheading = "subheading"
}

interface Props extends WidgetProps {
    fields: {
        [fields.image]: string;
        [fields.subheading]: string;
    };
}

export interface ImageAndTextEditorStyle {
    wrapperStyles?: InjectableCss;
    imageContainer?: InjectableCss;
    headingStyles?: InjectableCss;
    imageStyling?: InjectableCss;
    subHeadingStyles?: InjectableCss;
    hoverIconBoxButton?: InjectableCss;
}

export const ImageAndTextEditorStyle: ImageAndTextEditorStyle = {
    wrapperStyles: {
        css: css`
            display: flex;
            width: 100%;
            justify-content: center;
            align-items: center;
            @media only screen and (max-width: 700px) {
                flex-direction: column;
            }
        `,
    },
    imageContainer: {
        css: css`
            width: 38%
        `
    },
    imageStyling: {
        css: css`
            width: 100%;
            height: auto;
        `
    },
    subHeadingStyles: {
        css: css`
            width: 70%;
            margin-left: 40px;
            margin-top: 50px;
            @media only screen and (max-width: 700px) {
                margin-left: 0px;
                margin-top: 10px;
            }
        `
    }
};

export const ImageHoverBox: React.FC<Props> = props => {

    return (
        <StyledWrapper {...ImageAndTextEditorStyle.wrapperStyles}>
            <StyledWrapper {...ImageAndTextEditorStyle.imageContainer}>
                <img style={{width: "100%", height: "auto"}} src={props.fields.image} alt="" />
            </StyledWrapper>
            <StyledWrapper {...ImageAndTextEditorStyle.subHeadingStyles}>
                <Typography >
                    {parse(props.fields.subheading)}
                </Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ImageHoverBox,
    definition: {
        group: "Basic",
        icon: "ImageHoverBox",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.subheading,
                editorTemplate: "RichTextField",
                displayName: "Summary",
                defaultValue: "",
            }
        ],
    },
};

export default widgetModule;